function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.7245 3.80341L8.5674 17.3323C8.38083 17.6417 8.60367 18.0362 8.965 18.0362L13.0915 18.0363C13.3992 18.0363 13.6486 18.2857 13.6486 18.5934V27.2305H13.158V29.5711H13.91C14.0051 29.5779 14.1042 29.5367 14.165 29.4372L23.2384 14.5715C23.3517 14.3859 23.2181 14.1478 23.0006 14.1478H18.2921C18.0356 14.1478 17.8278 13.9399 17.8278 13.6835V2.97508C17.8278 2.80998 17.7007 2.70612 17.566 2.69674L16.7245 2.69604V3.80341Z",
  fill: "url(#paint0_linear_18_15539)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_18_15539)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.4931 2.83125L7.74977 17.3323C7.56321 17.6417 7.78604 18.0363 8.14735 18.0363L12.2739 18.0363C12.5816 18.0363 12.831 18.2857 12.831 18.5934V29.2921C12.831 29.5735 13.2007 29.6774 13.3473 29.4372L22.4208 14.5715C22.5341 14.3858 22.4005 14.1478 22.183 14.1478H17.4744C17.218 14.1478 17.0102 13.9399 17.0102 13.6835V2.97508C17.0102 2.69288 16.6388 2.58958 16.4931 2.83125Z",
  fill: "url(#paint1_linear_18_15539)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4931 2.83125L7.74977 17.3323C7.56321 17.6417 7.78604 18.0363 8.14735 18.0363L12.2739 18.0363C12.5816 18.0363 12.831 18.2857 12.831 18.5934V29.2921C12.831 29.5735 13.2007 29.6774 13.3473 29.4372L22.4208 14.5715C22.5341 14.3858 22.4005 14.1478 22.183 14.1478H17.4744C17.218 14.1478 17.0102 13.9399 17.0102 13.6835V2.97508C17.0102 2.69288 16.6388 2.58958 16.4931 2.83125Z",
  fill: "url(#paint2_linear_18_15539)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4931 2.83125L7.74977 17.3323C7.56321 17.6417 7.78604 18.0363 8.14735 18.0363L12.2739 18.0363C12.5816 18.0363 12.831 18.2857 12.831 18.5934V29.2921C12.831 29.5735 13.2007 29.6774 13.3473 29.4372L22.4208 14.5715C22.5341 14.3858 22.4005 14.1478 22.183 14.1478H17.4744C17.218 14.1478 17.0102 13.9399 17.0102 13.6835V2.97508C17.0102 2.69288 16.6388 2.58958 16.4931 2.83125Z",
  fill: "url(#paint3_radial_18_15539)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4931 2.83125L7.74977 17.3323C7.56321 17.6417 7.78604 18.0363 8.14735 18.0363L12.2739 18.0363C12.5816 18.0363 12.831 18.2857 12.831 18.5934V29.2921C12.831 29.5735 13.2007 29.6774 13.3473 29.4372L22.4208 14.5715C22.5341 14.3858 22.4005 14.1478 22.183 14.1478H17.4744C17.218 14.1478 17.0102 13.9399 17.0102 13.6835V2.97508C17.0102 2.69288 16.6388 2.58958 16.4931 2.83125Z",
  fill: "url(#paint4_linear_18_15539)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4931 2.83125L7.74977 17.3323C7.56321 17.6417 7.78604 18.0363 8.14735 18.0363L12.2739 18.0363C12.5816 18.0363 12.831 18.2857 12.831 18.5934V29.2921C12.831 29.5735 13.2007 29.6774 13.3473 29.4372L22.4208 14.5715C22.5341 14.3858 22.4005 14.1478 22.183 14.1478H17.4744C17.218 14.1478 17.0102 13.9399 17.0102 13.6835V2.97508C17.0102 2.69288 16.6388 2.58958 16.4931 2.83125Z",
  fill: "url(#paint5_radial_18_15539)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_18_15539",
  x: 7.68237,
  y: 2.69604,
  width: 14.7796,
  height: 26.8751,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.968627 0 0 0 0 0.431373 0 0 0 0 0.337255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_15539"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_15539",
  x1: 18.4074,
  y1: 7.96602,
  x2: 18.4074,
  y2: 23.7116,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBD61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EB5C74"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_18_15539",
  x1: 15.0722,
  y1: 11.05,
  x2: 15.0722,
  y2: 26.5859,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA547"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F14B49"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_18_15539",
  x1: 15.0722,
  y1: 2.69604,
  x2: 15.0722,
  y2: 13.7608,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DF9844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DF9844",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_18_15539",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.0992 7.9239) rotate(90) scale(6.45595 1.40857)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9052"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9052",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_18_15539",
  x1: 13.0633,
  y1: 8.37241,
  x2: 13.493,
  y2: 8.63022,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C76C38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C76C38",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_18_15539",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.157 7.71616) rotate(90) scale(6.6875 2.4375)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB54B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB54B",
  stopOpacity: 0
})));

function SvgHighVoltage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighVoltage);
export default __webpack_public_path__ + "static/media/high-voltage.f99118b4.svg";
export { ForwardRef as ReactComponent };